import React from "react";
import Badge from "../components/common/ui/badge/Badge";
import { CaseStatus, CasePriority } from "../types";

interface StatusBadgeConfig {
  color: "success" | "primary" | "light" | "dark";
  variant: "light" | "solid";
}

interface PriorityBadgeConfig {
  color: "light" | "info" | "warning" | "error";
  variant: "light" | "solid";
}

const STATUS_BADGE_CONFIG: Record<CaseStatus, StatusBadgeConfig> = {
  [CaseStatus.OPEN]: {
    color: "success",
    variant: "light",
  },
  [CaseStatus.IN_PROGRESS]: {
    color: "primary",
    variant: "light",
  },
  [CaseStatus.CLOSED]: {
    color: "light",
    variant: "light",
  },
  [CaseStatus.ARCHIVED]: {
    color: "dark",
    variant: "light",
  },
};

const PRIORITY_BADGE_CONFIG: Record<CasePriority, PriorityBadgeConfig> = {
  [CasePriority.LOW]: {
    color: "light",
    variant: "light",
  },
  [CasePriority.MEDIUM]: {
    color: "info",
    variant: "light",
  },
  [CasePriority.HIGH]: {
    color: "warning",
    variant: "light",
  },
  [CasePriority.URGENT]: {
    color: "error",
    variant: "light",
  },
};

export const CaseStatusBadge: React.FC<{ status: CaseStatus }> = ({
  status,
}) => {
  const config = STATUS_BADGE_CONFIG[status];
  return (
    <Badge color={config.color} variant={config.variant}>
      {status}
    </Badge>
  );
};

export const CasePriorityBadge: React.FC<{ priority: CasePriority }> = ({
  priority,
}) => {
  const config = PRIORITY_BADGE_CONFIG[priority];
  return (
    <Badge color={config.color} variant={config.variant}>
      {priority}
    </Badge>
  );
};
